import { render, staticRenderFns } from "./StateTax.vue?vue&type=template&id=805dda6e&scoped=true&"
import script from "./StateTax.vue?vue&type=script&lang=js&"
export * from "./StateTax.vue?vue&type=script&lang=js&"
import style0 from "bootstrap/dist/css/bootstrap.min.css?vue&type=style&index=0&id=805dda6e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "805dda6e",
  null
  
)

export default component.exports